export default "__VITE_ASSET__B5Y3B0_H__"